module.exports = ".width50{width:50%}.full-width{width:100%}\n"